import {Alert, message} from 'antd';
import { SoundOutlined } from '@ant-design/icons';
import Marquee from 'react-fast-marquee';
import BannerCarousel from '../BannerCarousel';
import ServiceModules from '../ServiceModules';
import s from './index.module.css';
import {useEffect, useState} from "react";
import {getNotice} from "../../server/api";

const Banner = ({ onModuleChange }) => {
    const [notice, setNotice] = useState({});

    useEffect(() => {
        requestNotice();
    }, [])

    const requestNotice = async () => {
        let params = {
            type: 1,
        };
        getNotice(params)
            .then(function (res) {
                const { status, data: { result } } = res;
                if (status === 200) {
                    setNotice(result);
                    return;
                }
                message.error('查询数据出错，请刷新重试！');
            })
            .catch(function (error) {
            });
    }

  const handleModuleChange = (module, slideDirection) => {
    if (onModuleChange) {
      onModuleChange(module, slideDirection);
    }
  };

  return (
    <div className={s.bannerContainer}>
      <div className={s.bannerContent}>
        <BannerCarousel />

        <ServiceModules onModuleChange={handleModuleChange} />

        <div className={s.bannerAlert}>
          <Alert
            banner
            icon={<SoundOutlined />}
            message={
              <Marquee pauseOnHover gradient={false}>
                  {/*庆阳市质量基础设施云平台正式上线！‌ 平台整合计量、标准、认证认可等核心服务，为企业提供检测报告查询、业务办理、政策咨询等一站式解决方案。通过数字化赋能，助力质量提升与产业升级。诚邀企业、机构及个人用户访问体验，共筑质量强市！*/}
                  {(notice?.records || []).map((msg, index) => (
                      <span key={index} style={{ marginRight: '100px' }}>
                        {msg.content}
                      </span>
                    ))}

              </Marquee>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
